
const initialState = {
  data: [],
  loading: false,
  success: false,
  error: false,
  filterValues: undefined,
};

export const attachmentGetByIdRequest = (namespace) => (state = initialState, action) => {
  switch (action.type) {
    case `${namespace}/ATTACHMENT_GET_BY_ID_REQUEST_REQUEST`: {
      return { ...initialState, data: state.data, loading: true };
    }
    case `${namespace}/ATTACHMENT_GET_BY_ID_REQUEST_SUCCESS`: {
      return { ...state, data: action.data, success: false, loading: false };
    }
    case `${namespace}/ATTACHMENT_GET_BY_ID_REQUEST_FAILURE`: {
      return { ...state, data: [], success: false, error: action.error, loading: false };
    }
    case `${namespace}/ATTACHMENT_GET_BY_ID_REQUEST_SET_FILTER_VALUES`: {
      return { ...state, filterValues: action.data };
    }
    case `${namespace}/ATTACHMENT_GET_BY_ID_REQUEST_RESET_FILTER_VALUES`: {
      return { ...state, filterValues: undefined };
    }
    case `${namespace}/ATTACHMENT_GET_BY_ID_REQUEST_RESET`: {
      return initialState;
    }
    default:
      return state;
  }
};
